module.exports = __webpack_public_path__ + "img/image-4.b5740a3d.jpg";